/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  TransactionOtherFull,
  TransactionOtherFullOptional,
  TransactionOtherFullMetaI,
  TransactionOtherFullTrackedI,
} from "./transaction-other-full";
import {
  TransactionOtherFullTracked,
  TransactionOtherFullMeta,
} from "./transaction-other-full";

/**
 *
 * @export
 * @interface TransactionOtherDTO
 */
export interface TransactionOtherDTOOptional extends TransactionOtherFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof TransactionOtherDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TransactionOtherDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof TransactionOtherDTO
   */
  assignId?: number;
  /**
   *
   * @type {PaymentType}
   * @memberof TransactionOtherDTO
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherDTO
   */
  paymentTypeOther?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherDTO
   */
  transactionInfo?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherDTO
   */
  transactionExtra?: string;
  /**
   *
   * @type {number}
   * @memberof TransactionOtherDTO
   */
  transactionAmount?: number;
}

export interface TransactionOtherDTO
  extends TransactionOtherDTOOptional, TransactionOtherFull {
  /**
   *
   * @type {boolean}
   * @memberof TransactionOtherDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TransactionOtherDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof TransactionOtherDTO
   */
  assignId: number;
  /**
   *
   * @type {PaymentType}
   * @memberof TransactionOtherDTO
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherDTO
   */
  paymentTypeOther?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherDTO
   */
  transactionInfo?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherDTO
   */
  transactionExtra?: string;
  /**
   *
   * @type {number}
   * @memberof TransactionOtherDTO
   */
  transactionAmount?: number;
}

export interface TransactionOtherDTOTrackedI extends TransactionOtherFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof TransactionOtherDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TransactionOtherDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof TransactionOtherDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {PaymentType}
   * @memberof TransactionOtherDTO
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherDTO
   */
  paymentTypeOther?: string;
  paymentTypeOtherIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherDTO
   */
  transactionInfo?: string;
  transactionInfoIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherDTO
   */
  transactionExtra?: string;
  transactionExtraIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof TransactionOtherDTO
   */
  transactionAmount?: number;
  transactionAmountIsSet: boolean;
}

transformDatesMap.set(
  "TransactionOtherDTO",
  function (model: TransactionOtherDTO) {},
);

export type TransactionOtherDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  paymentTypeOther: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  transactionInfo: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  transactionExtra: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  transactionAmount: PropertyMeta<MetaTypeBase<number>>;
}>;

export var TransactionOtherDTOMeta: TransactionOtherDTOMetaI =
  {} as TransactionOtherDTOMetaI;
TransactionOtherDTOMeta = typeMeta("TransactionOtherDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  paymentType: propertyMeta(
    "paymentType",
    false,
    false,
    false,
    PaymentTypeMeta,
  ),
  paymentTypeOther: propertyMeta(
    "paymentTypeOther",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  transactionInfo: propertyMeta(
    "transactionInfo",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  transactionExtra: propertyMeta(
    "transactionExtra",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  transactionAmount: propertyMeta(
    "transactionAmount",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = TransactionOtherDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([TransactionOtherFullMeta]);
  metaI.isDeleted.inheritedFrom = TransactionOtherFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = TransactionOtherFullMeta.isNew;
  metaI.assignId.inheritedFrom = TransactionOtherFullMeta.assignId;
  metaI.paymentType.inheritedFrom = TransactionOtherFullMeta.paymentType;
  metaI.paymentTypeOther.inheritedFrom =
    TransactionOtherFullMeta.paymentTypeOther;
  metaI.transactionInfo.inheritedFrom =
    TransactionOtherFullMeta.transactionInfo;
  metaI.transactionExtra.inheritedFrom =
    TransactionOtherFullMeta.transactionExtra;
  metaI.transactionAmount.inheritedFrom =
    TransactionOtherFullMeta.transactionAmount;
});

export class TransactionOtherDTOTracked
  extends TransactionOtherFullTracked
  implements TransactionOtherDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  paymentTypeOther__I?: string = undefined;
  paymentTypeOtherIsSet: boolean = false;
  set paymentTypeOther(v: undefined | string) {
    if (v !== undefined) {
      this.paymentTypeOther__I = v;
      this.paymentTypeOtherIsSet = true;
    } else {
      this.paymentTypeOther__I = v || undefined;
      this.paymentTypeOtherIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTypeOther() {
    return this.paymentTypeOther__I;
  }
  transactionInfo__I?: string = undefined;
  transactionInfoIsSet: boolean = false;
  set transactionInfo(v: undefined | string) {
    if (v !== undefined) {
      this.transactionInfo__I = v;
      this.transactionInfoIsSet = true;
    } else {
      this.transactionInfo__I = v || undefined;
      this.transactionInfoIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionInfo() {
    return this.transactionInfo__I;
  }
  transactionExtra__I?: string = undefined;
  transactionExtraIsSet: boolean = false;
  set transactionExtra(v: undefined | string) {
    if (v !== undefined) {
      this.transactionExtra__I = v;
      this.transactionExtraIsSet = true;
    } else {
      this.transactionExtra__I = v || undefined;
      this.transactionExtraIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionExtra() {
    return this.transactionExtra__I;
  }
  transactionAmount__I?: number = undefined;
  transactionAmountIsSet: boolean = false;
  set transactionAmount(v: undefined | number) {
    if (v !== undefined) {
      this.transactionAmount__I = v;
      this.transactionAmountIsSet = true;
    } else {
      this.transactionAmount__I = v || undefined;
      this.transactionAmountIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionAmount() {
    return this.transactionAmount__I;
  }
  constructor(config?: TransactionOtherDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: TransactionOtherDTOOptional,
    options?: AssignOptions,
  ): TransactionOtherDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (
      config.paymentTypeOther &&
      this.paymentTypeOtherApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTypeOther = config.paymentTypeOther;
      if (optionsRequired.unassign) this.paymentTypeOtherIsSet = false;
      else this.paymentTypeOtherIsSet = true;
    }
    if (
      config.transactionInfo &&
      this.transactionInfoApplyFilter(optionsRequired.filter)
    ) {
      this.transactionInfo = config.transactionInfo;
      if (optionsRequired.unassign) this.transactionInfoIsSet = false;
      else this.transactionInfoIsSet = true;
    }
    if (
      config.transactionExtra &&
      this.transactionExtraApplyFilter(optionsRequired.filter)
    ) {
      this.transactionExtra = config.transactionExtra;
      if (optionsRequired.unassign) this.transactionExtraIsSet = false;
      else this.transactionExtraIsSet = true;
    }
    if (
      config.transactionAmount &&
      this.transactionAmountApplyFilter(optionsRequired.filter)
    ) {
      this.transactionAmount = config.transactionAmount;
      if (optionsRequired.unassign) this.transactionAmountIsSet = false;
      else this.transactionAmountIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): TransactionOtherDTOTrackedI {
    const cloned = {} as TransactionOtherDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.paymentTypeOtherIsSetDeep() &&
      this.paymentTypeOtherApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeOtherIsSet = true;
      cloned.paymentTypeOther = this.paymentTypeOther;
    } else {
      //cloned.paymentTypeOtherIsSet = false
    }
    if (
      this.transactionInfoIsSetDeep() &&
      this.transactionInfoApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionInfoIsSet = true;
      cloned.transactionInfo = this.transactionInfo;
    } else {
      //cloned.transactionInfoIsSet = false
    }
    if (
      this.transactionExtraIsSetDeep() &&
      this.transactionExtraApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionExtraIsSet = true;
      cloned.transactionExtra = this.transactionExtra;
    } else {
      //cloned.transactionExtraIsSet = false
    }
    if (
      this.transactionAmountIsSetDeep() &&
      this.transactionAmountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionAmountIsSet = true;
      cloned.transactionAmount = this.transactionAmount;
    } else {
      //cloned.transactionAmountIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): TransactionOtherDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.paymentTypeOtherApplyFilter(filter))
      this.paymentTypeOtherIsSet = false;

    if (!this.transactionInfoApplyFilter(filter))
      this.transactionInfoIsSet = false;

    if (!this.transactionExtraApplyFilter(filter))
      this.transactionExtraIsSet = false;

    if (!this.transactionAmountApplyFilter(filter))
      this.transactionAmountIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherDTOMeta.isDeleted,
      TransactionOtherDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherDTOMeta.isNew,
      TransactionOtherDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherDTOMeta.assignId,
      TransactionOtherDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherDTOMeta.paymentType,
      TransactionOtherDTOMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  paymentTypeOtherApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherDTOMeta.paymentTypeOther,
      TransactionOtherDTOMeta,
      this.paymentTypeOther,
      this,
    );
  }
  paymentTypeOtherIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeOtherIsSet && this.paymentTypeOtherApplyFilter(filter))
      return true;

    return false;
  }
  transactionInfoApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherDTOMeta.transactionInfo,
      TransactionOtherDTOMeta,
      this.transactionInfo,
      this,
    );
  }
  transactionInfoIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.transactionInfoIsSet && this.transactionInfoApplyFilter(filter))
      return true;

    return false;
  }
  transactionExtraApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherDTOMeta.transactionExtra,
      TransactionOtherDTOMeta,
      this.transactionExtra,
      this,
    );
  }
  transactionExtraIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.transactionExtraIsSet && this.transactionExtraApplyFilter(filter))
      return true;

    return false;
  }
  transactionAmountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherDTOMeta.transactionAmount,
      TransactionOtherDTOMeta,
      this.transactionAmount,
      this,
    );
  }
  transactionAmountIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionAmountIsSet &&
      this.transactionAmountApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.paymentTypeOtherIsSetDeep(filter)) return true;
    if (this.transactionInfoIsSetDeep(filter)) return true;
    if (this.transactionExtraIsSetDeep(filter)) return true;
    if (this.transactionAmountIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
